
// MODal

import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const AuthorityModalPopup = ({ AuthRityDataFetchFunc, onClose }) => {
  const fileInputRef = useRef(null);

  // Fetch File Login Data
  const fetchFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
        },
      });
      console.log("File Login Data:", response.data);
    } catch (error) {
      console.error("Error fetching file login data:", error);
    }
  };

  useEffect(() => {
    fetchFileLoginData();
  }, []);

  const [loading, setLoading] = useState(false);
  const [radioValue, setRadioValue] = useState(false);
  const [allBranch, setAllBranch] = useState([]);

  // Purpose
  const [datastatus, setDataStatus] = useState([
    { label: "Document Verification", value: 1 },
    { label: "Document Retrieval", value: 2 },
  ]);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    Purpose: "",
    IsPurposeMet: false,
    Selfie: null,
    Latitude: "",
    Longitude: "",
  });

  // Fetch Branch Data
  const fetchBranchData = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
        },
      });
      setAllBranch(response.data.data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    fetchBranchData();
  }, []);

  // Handle File Change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData((prev) => ({ ...prev, Selfie: file }));
  };

  // Handle Form Validation
  const validateForm = () => {
    if (!LocalFormData.BranchId) {
      ErrorToast("Please select a branch.");
      return false;
    }
    if (!LocalFormData.Purpose) {
      ErrorToast("Please select a Purpose.");
      return false;
    }
    if (!LocalFormData.Name) {
      ErrorToast("Please enter the customer's name.");
      return false;
    }
    if (!LocalFormData.Mobile || LocalFormData.Mobile.length !== 10) {
      ErrorToast("Please enter a valid 10-digit mobile number.");
      return false;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("Please upload a document.");
      return false;
    }
    return true;
  };

  // Handle Form Submission
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("Purpose", LocalFormData.Purpose);
    formData.append("IsPurposeMet", LocalFormData.IsPurposeMet);
    formData.append("Selfie", LocalFormData.Selfie);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(`${Api_Url}api/v1/AuthorityVisit`, formData, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      SuccessToast("Authority Data Submitted Successfully");
      AuthRityDataFetchFunc();
      resetForm();
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting the form.");
      console.error("Submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Reset Form
  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      Purpose: "",
      IsPurposeMet: false,
      Selfie: null,
      Latitude: "",
      Longitude: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Handle Mobile Change
  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]{0,10}$/.test(value)) {
      setLocalFormData((prev) => ({ ...prev, Mobile: value }));
    }
  };

  // Handle Radio Change
  const handleRadioChange = (e) => {
    setLocalFormData((prev) => ({ ...prev, IsPurposeMet: e.target.value === "true" }));
  };

  // Get User's Location
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setLocalFormData((prev) => ({ ...prev, Latitude: latitude, Longitude: longitude }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  return (
    <Modal
      title={<h4>Authority Visit</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div className="d-flex justify-content-between align-items-center" key="footer">
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.BranchId}
                  onChange={(e) =>
                    setLocalFormData((prev) => ({ ...prev, BranchId: e.target.value }))
                  }
                >
                  <option value="">Select Branch</option>
                  {allBranch.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Customer Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Name}
                  onChange={(e) =>
                    setLocalFormData((prev) => ({ ...prev, Name: e.target.value }))
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Purpose <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={LocalFormData.Purpose}
                  onChange={(e) =>
                    setLocalFormData((prev) => ({ ...prev, Purpose: e.target.value }))
                  }
                >
                  <option value="">Select Purpose</option>
                  {datastatus.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Upload Document <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <label className="col-form-label">
                Purpose Met <span className="text-danger">*</span>
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="purposeMet"
                  id="purposeMetYes"
                  value="true"
                  checked={LocalFormData.IsPurposeMet === true}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="purposeMetYes">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="purposeMet"
                  id="purposeMetNo"
                  value="false"
                  checked={LocalFormData.IsPurposeMet === false}
                  onChange={handleRadioChange}
                />
                <label className="form-check-label" htmlFor="purposeMetNo">
                  No
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};


{
  /* <div className="col-md-12">
<label className="col-form-label">
    File Logged In <span className="text-danger">*</span>
</label>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault1"
        value="true"
        checked={radioValue === true}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault1">
        Yes
    </label>
</div>
<div className="form-check">
    <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault2"
        value="false"
        checked={radioValue === false}
        onChange={handleRadioChange}
    />
    <label className="form-check-label" htmlFor="flexRadioDefault2">
        No
    </label>
</div>
</div> */
}

{
  /* Conditional rendering based on radio selection */
}
// {radioValue === true ? (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Application Number <span className="text-danger">*</span>
//         </label>
//         <input
//             className="form-control"
//             type="text"
//             value={localFormData.ApplicationNo}
//             onChange={(e) => setLocalFormData({ ...localFormData, ApplicationNo: e.target.value })}
//         />
//     </div>
// </div>
// ) : (
// <div className="col-md-6">
//     <div className="input-block mb-3">
//         <label className="col-form-label">
//             Visit Date <span className="text-danger">*</span>
//         </label>
//         <DatePicker
//             selected={localFormData.VisitDate}
//             onChange={handleDateChange}
//             className="form-control"
//             minDate={new Date()}
//         />
//     </div>
// </div>
// )}
